import { requestWithBody } from './fetch';

export const updatePolarisConfig = (customerId: number, config: any) => {
  return requestWithBody({ endpoint: `api/customer/${customerId}/polaris`, body: config }, 'PATCH');
};

export const createPolarisConfig = (customerId: number, config: any) => {
  return requestWithBody({ endpoint: `api/customer/${customerId}/polaris`, body: config }, 'POST');
};

export const syncPolaris = () => {
  return requestWithBody({ endpoint: `api/customer/sync-polaris`, body: {} }, 'PATCH');
};